export default {
  "content": "<g fill=\"#3F4450\" clip-path=\"url(#a)\"><path d=\"M12 12a6 6 0 100-12 6 6 0 000 12zm4.5 3h-9A4.5 4.5 0 003 19.5v4.163a.337.337 0 00.337.337h17.326a.337.337 0 00.337-.337V19.5a4.5 4.5 0 00-4.5-4.5z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none"
  }
};